import React from 'react';
import styles from './Home.module.scss';
import { useOutletContext } from 'react-router-dom';
import { AppConfig, Topic } from '../../Models';
import { Banner } from './Banner/Banner';
import { MainActions } from './MainActions/MainActions';
import { SuggestedTopics } from './SuggestedTopics/SuggestedTopics';
import { SearchTopics } from './SearchTopics/SearchTopics';
import { getTopicsByIds } from '../../Helpers';

function Home() {
  const config = useOutletContext<AppConfig>();

  const mainActions: Topic[] = getTopicsByIds(
    config,
    config.body.main_action.topic_ids
  );

  const activeTopics: Topic[] = config.body.topics.filter(
    (topic: Topic) => topic.active
  );

  return (
    <div className={styles.home}>
      <Banner banner={config.header.banner} brand={config.header.brand} />

      <div className={styles.content}>
        <MainActions
          title_desktop={config.body.main_action.title_desktop}
          title_mobile={config.body.main_action.title_mobile}
          topics={mainActions}
        />

        <hr />

        <SearchTopics topics={activeTopics} />

        <hr />

        <SuggestedTopics topics={activeTopics} />
      </div>
    </div>
  );
}

export default Home;
